define('viewmodels/Weightings_Thresholds/SanctionsThresholds',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'], function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'RiskLevel';

    var AtViewModel = {
        title: title,
        attached: attached,
        detached: detached,
        appsecurity: appsecurity,
        AssessmentType: ko.observable("SANC"),
        RiskAreaList: ko.observableArray(),
        RiskAreaTabClick: RiskAreaTabClick,
        RiskFactorTabClick: RiskFactorTabClick,
        RiskFactorList: ko.observableArray(),
        ClickedRiskAreaId: ko.observable(),
        ClickedRiskAreaType: ko.observable(),
        ClickedRiskAreaName: ko.observable(),
        ClickedRiskFactorId: ko.observable(),
        ClickedRiskFactorName: ko.observable(),
        ThresholdValuesList: ko.observableArray(),
        ThresholdValuesListDup: ko.observableArray(),
        ThresholdChildList: ko.observableArray(),
        ThresholdCellBlur: ThresholdCellBlur,
        ResetThresholdData: ResetThresholdData,
        SaveThresholdBtnClick: SaveThresholdBtnClick,
        countEntry: ko.observable(0),
        GreyOutCells: GreyOutCells,
        ErrorStatus: ko.observable(0),
        PrevRAId: ko.observable(),
        FactorCountEntry: ko.observable(0),
        PrevFactorId: ko.observable(),
        InputChange: InputChange,
        InputChangeEvent: ko.observable(false),
        SaveButtonClick: ko.observable(false),
        SaveQualitativeThresholdValues: SaveQualitativeThresholdValues,
        onBlurEvent: onBlurEvent,
        QualThresholdValuesList: ko.observableArray(),
        QualThresholdValuesListDup: ko.observableArray([]),
        onKeyPressvalidateNumber: onKeyPressvalidateNumber,
        ResetQualitativeThresholdValues: ResetQualitativeThresholdValues

    };

    return AtViewModel;

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            AtViewModel.appsecurity.GetCurrentYearOfAssessment().then(function () {
                AtViewModel.appsecurity.getYearOfAssessmentDetails().then(function () {
                    if (AtViewModel.appsecurity.isConfigurationFreeze() == 1) {
                        AtViewModel.appsecurity.WriteAccess(false);
                        GetAllRiskAreas();
                    }
                    else {
                        GetAllRiskAreas();
                    }
                })
            })
            AtViewModel.countEntry(0);
            $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');

            var url = window.location.pathname;
            var filename = url.substring(url.lastIndexOf('/') + 1);
            $(document).on('change', 'input', function (e) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/') + 1);
                if (filename == "SanctionsThresholds") {
                    Greyinput(e.currentTarget.id);
                }
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    };

    //--------------------------------------------------------------------draw threshold table--------------------------------------------------------------------------
    function Greyinput(id) {
        try {
            var z = $('#' + id).val();
            if (z == 100) {
                $('#' + id).addClass("grey");
                $('#' + id).removeClass("whiteinput");
            }
            else {
                $('#' + id).addClass("whiteinput");
                $('#' + id).removeClass("grey");
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Greyinput() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }
    function GreyOutCells() {
        try {
            for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                var x = AtViewModel.ThresholdValuesList()[i].IrlId()
                for (var j = 0; j < AtViewModel.ThresholdChildList().length; j++) {
                    var y = AtViewModel.ThresholdChildList()[j].RiskLevelId()
                    var z = $('#' + y + '_' + x).val()
                    if (z == 100) {
                        $('#' + y + '_' + x).addClass("grey");
                        $('#' + y + '_' + x).removeClass("whiteinput");
                    }
                    else {
                        $('#' + y + '_' + x).addClass("whiteinput");
                        $('#' + y + '_' + x).removeClass("grey");
                    }

                }
            }
        }
        catch (e) {

        }
    }
    function InputChange() {
        GreyOutCells();
        AtViewModel.InputChangeEvent(true);
    }

    function GetAllRiskAreas() {
        try {

            $.ajax({

                url: "/api/Configuration/GetAllRiskAreas",
                data: { "AssessmentType": AtViewModel.AssessmentType(), "AreaType": "ALL" },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult[0].RiskAreaName != null) {
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        return new RiskAreaModel(result);
                    });

                    AtViewModel.RiskAreaList(mappedRiskAreaList);

                    $('#RaTab').tabs();
                    $($('#RiskAreaUl li').get(0)).trigger('click');

                }
                else if (jsonResult[0].RiskAreaName == null)
                    app.showMessage("Risk Areas are not yet configured for this year of assessment. Please configure the Risk Areas to before setting Thresholds", "Error in Fetching Risk Areas", ["OK"])
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration/RisksAreasfactors", true);
                    })
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AtViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SanctionsThreshold.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetAllRiskFactors() {
        try {
            AtViewModel.PrevRAId(AtViewModel.ClickedRiskAreaId());
            $.ajax({
                url: "/api/Configuration/GetAllRiskfactorAreaWise",
                type: "GET",
                async: false,
                data: { "RiskAreaId": AtViewModel.ClickedRiskAreaId(), "AssessmentType": AtViewModel.AssessmentType() },
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskFactors() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length == 0) {
                    $('#RiskAreaTabDiv').hide();
                    $('#Sancerror').show();

                }
                else if (jsonResult != null && jsonResult[0].RiskFactorName != null) {
                    $('#Sancerror').hide();
                    var mappedRiskFactorList = $.map(jsonResult, function (result) {
                        return new RiskFactorModel(result);
                    });
                    AtViewModel.RiskFactorList(mappedRiskFactorList);

                    $('#RfTab').tabs();
                    $('#RfTab').tabs('refresh');
                    $('#RfTab').tabs({ active: 0 });
                    $($('#RiskFactorUl li').get(0)).trigger('click');
                    scrollableTabs();
                }
                else if (jsonResult[0].RiskFactorName == null)
                    app.showMessage("Risk Factors are not yet configured for this year of assessment. Please configure the Risk Factors to before setting Thresholds.", "Risk Factors are not configured.", ["OK"])
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration/RisksAreasfactors", true);
                    })
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AtViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskFactors() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactors() method in SanctionsThreshold.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactors() method in AMLInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
    }

    function RiskAreaTabClick(data, event) {
        try {
            if (data.IsQualitative() == "0") {
                $('#QualitativeTabDiv').hide();
                $('#RfTab').show();
                if (AtViewModel.appsecurity.WriteAccess() == false || AtViewModel.appsecurity.WriteAccess() == "false") {
                    AtViewModel.countEntry(0);
                    AtViewModel.FactorCountEntry(0);
                }
                if (AtViewModel.countEntry() == 0) {
                    AtViewModel.countEntry(1);
                    $('#lblThresholdValidation').hide();
                    AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                    AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                    //$('#' + AtViewModel.PrevRAId()).addClass('ui-tabs-active ui-state-active');
                    //$('#' + data.RiskAreaId()).removeClass('ui-tabs-active ui-state-active');
                    GetAllRiskFactors();
                }
                else if (AtViewModel.InputChangeEvent() && AtViewModel.SaveButtonClick() == false) {
                    AtViewModel.InputChangeEvent(false);
                    app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                    .then(function (option) {
                        if (option == "Save") {
                            $('#btnSaveThreshold').click();
                            AtViewModel.countEntry(0);
                            AtViewModel.FactorCountEntry(0);
                            if (AtViewModel.ErrorStatus() == 1) {
                                AtViewModel.ErrorStatus(0);
                                $('#' + AtViewModel.PrevRAId()).addClass('ui-tabs-active ui-state-active');
                                $('#' + data.RiskAreaId()).removeClass('ui-tabs-active ui-state-active');
                            }
                            else {
                                AtViewModel.SaveButtonClick(false);
                                AtViewModel.countEntry(0);
                                $('#lblThresholdValidation').hide();
                                $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                                $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                                RiskAreaTabClick(data, event);
                            }
                        }
                        else {
                            //AtViewModel.WeightingsType('');
                            AtViewModel.countEntry(1);
                            $('#lblThresholdValidation').hide();
                            AtViewModel.FactorCountEntry(0);
                            $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                            $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                            AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                            AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                            GetAllRiskFactors();
                        }
                    })
                }
                else {
                    AtViewModel.InputChangeEvent(false);
                    AtViewModel.countEntry(0);
                    $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                    $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                    RiskAreaTabClick(data, event);
                }
            }
            else {
                if (data.IsQualitative() == "1")
                    $('#QualitativeTabDiv').show();
                $('#loadingImgMainQual').show();
                $('#RfTab').hide();
                $('#qualfactordiv').hide();
                AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                AtViewModel.ClickedRiskAreaType(data.RiskAreaType());
                GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }


    function RiskFactorTabClick(data, event) {
        try {
            if (AtViewModel.appsecurity.WriteAccess() == false || AtViewModel.appsecurity.WriteAccess() == "false") {
                AtViewModel.FactorCountEntry(0);
            }
            if (AtViewModel.FactorCountEntry() == 0) {
                AtViewModel.FactorCountEntry(1);
                $('#loadingImgMain').show();
                $('#FactorDataDiv').hide();
                $('#lblThresholdValidation').hide();
                AtViewModel.ClickedRiskFactorId(data.RiskFactorId());
                AtViewModel.ClickedRiskFactorName(data.RiskFactorName());
                $('#FAC_' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                GetThresholdData();
            }
            else if (AtViewModel.InputChangeEvent() && AtViewModel.SaveButtonClick() == false) {
                AtViewModel.InputChangeEvent(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                                .then(function (option) {
                                    if (option == "Save") {
                                        $('#btnSaveThreshold').click();
                                        AtViewModel.FactorCountEntry(0);
                                        if (AtViewModel.ErrorStatus() == 1) {
                                            AtViewModel.ErrorStatus(0);
                                            $('#FAC_' + AtViewModel.PrevFactorId()).addClass('ui-tabs-active ui-state-active');
                                            $('#FAC_' + data.RiskFactorId()).removeClass('ui-tabs-active ui-state-active');
                                        }
                                        else {
                                            AtViewModel.SaveButtonClick(false);
                                            AtViewModel.FactorCountEntry(0);
                                            $('#FAC_' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                                            $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                                            RiskFactorTabClick(data, event);
                                        }
                                    }
                                    else {
                                        //AtViewModel.WeightingsType('');
                                        AtViewModel.FactorCountEntry(1);
                                        $('#lblThresholdValidation').hide();
                                        $('#FAC_' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                                        $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                                        $('#loadingImgMain').show();
                                        $('#FactorDataDiv').hide();
                                        AtViewModel.ClickedRiskFactorId(data.RiskFactorId());
                                        AtViewModel.ClickedRiskFactorName(data.RiskFactorName());
                                        GetThresholdData();
                                    }
                                })
            }
            else {
                AtViewModel.InputChangeEvent(false);
                AtViewModel.SaveButtonClick(false);
                AtViewModel.FactorCountEntry(0);
                $('#FAC_' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                RiskFactorTabClick(data, event);
            }
            //$('#loadingImgMain').show();
            //$('#FactorDataDiv').hide();
            //AtViewModel.ClickedRiskFactorId(data.RiskFactorId());
            //AtViewModel.ClickedRiskFactorName(data.RiskFactorName());
            //GetThresholdData();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorTabClick() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function GetThresholdData() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetFactorThreshold?RiskFactorId=" + AtViewModel.ClickedRiskFactorId() + "&AssessmentType=" + AtViewModel.AssessmentType() + "&TableType=F",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetThresholdData() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                $('#loadingImgMain').hide();
                $('#FactorDataDiv').show();
                var MappedThresholdValue = $.map(jsonResult, function (result) {
                    return new ThresholdValueModel(result);
                });
                $('#tblThreshold tbody tr').remove();
                AtViewModel.ThresholdValuesList(MappedThresholdValue);

                var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                    return new ThresholdValueModel(result);
                });
                AtViewModel.ThresholdValuesListDup(MappedThresholdValueDup);

                AtViewModel.ThresholdChildList(AtViewModel.ThresholdValuesList()[0].ChildList());
                GreyOutCells();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetThresholdData() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetThresholdData() method in SanctionsThreshold.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetThresholdData() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }
    }

    function ThresholdCellBlur(data, event) {
        try {
            var RiskLevelId = event.currentTarget.parentNode.parentNode.id;
            var Value = event.currentTarget.value;
            ValidateThresholdValues(data.IrlId(), RiskLevelId, Value);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdCellBlur() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ValidateThresholdValues(IrlId, RiskLevelId, Value) {
        try {
            var Result = false;
            var ColumnIndex = 0;
            var RowIndex = 0;
            for (var i = 0; i < $('#tblThreshold thead tr th').length; i++) {
                if ($('#tblThreshold thead tr th').get(i).id == IrlId)
                    ColumnIndex = i;
            }
            ColumnIndex = (ColumnIndex * 2) + 1;
            for (var i = 0; i < $('#tblThreshold tbody tr').length; i++) {
                if ($($('#tblThreshold tbody tr').get(i)).find('td').get(ColumnIndex).id == RiskLevelId)
                    RowIndex = i;
            }
            var ErrorMsg = "";

            if (Value == "" || Value == undefined) {
                ErrorMsg = "Value cannot be left blank";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else if (isNaN(Value)) {
                ErrorMsg = "Non-Numeric Value is not allowed";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else if (Value < 0 || Value > 100) {
                ErrorMsg = "Value should be in range 0 - 100";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else {
                if ((parseFloat(Value).toString().indexOf('.') < 0) ? true : ((parseFloat(Value).toString().split('.')[1].length <= 2) ? true : false)) {
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').removeAttr('style');
                    ErrorMsg = "";
                    Result = true;
                }
                else {
                    ErrorMsg = "Decimal Upto Only 2 Places is Allowed";
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
                }
            }
            if (ErrorMsg.length > 0) {
                AtViewModel.ErrorStatus(1);
            }
            $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('label').text(ErrorMsg);
            return Result;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ValidateThresholdValues() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ConvertObservableToObject(Data) {
        try {
            var ThresholdValue = new Array();
            for (var i = 0; i < Data().length; i++) {
                var Child = new Array();
                for (j = 0; j < Data()[i].ChildList().length; j++) {
                    Child.push(new Object({
                        RiskLevelId: Data()[i].ChildList()[j].RiskLevelId(),
                        RiskLevelName: Data()[i].ChildList()[j].RiskLevelName(),
                        RiskLevelCss: Data()[i].ChildList()[j].RiskLevelCss()
                    }));
                }
                ThresholdValue.push(new Object({
                    IrlId: Data()[i].IrlId(),
                    IrlName: Data()[i].IrlName(),
                    Child: Child
                }));
            }
            return ThresholdValue;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ConvertObservableToObject() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ResetThresholdData() {
        try {
            for (var i = 1; i < AtViewModel.ThresholdValuesListDup().length; i++) {
                for (var j = 0; j < AtViewModel.ThresholdValuesListDup()[i].ChildList().length; j++) {
                    var Value = AtViewModel.ThresholdValuesListDup()[i].ChildList()[j].RiskLevelName();
                    AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName(Value);
                }
            }
            $('#tblThreshold tbody input').removeAttr('style');
            $('#tblThreshold tbody #lblValidation').text("");
            $('#lblThresholdValidation').text("");
            $('#lblThresholdValidation').hide();
            GreyOutCells();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResetThresholdData() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function SaveThresholdBtnClick() {
        try {
            AtViewModel.SaveButtonClick(true);
            var Counter = 0;
            for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                for (var j = 0; j < AtViewModel.ThresholdValuesList()[i].ChildList().length; j++) {
                    if (!(ValidateThresholdValues(AtViewModel.ThresholdValuesList()[i].IrlId(), AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelId(), AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName())))
                        Counter++;
                }
            }
            if (Counter == 0) {
                $('#lblThresholdValidation').text("");
                $('#lblThresholdValidation').hide();
                var ObjectData = ConvertObservableToObject(AtViewModel.ThresholdValuesList);
                SaveThresholdValues(ObjectData);
            }
            else {
                $('#lblThresholdValidation').text("Please correct the errors highlighted in below cells before saving the Threshold data.");
                $('#lblThresholdValidation').show();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveThresholdBtnClick() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function SaveThresholdValues(ObjectData) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({ 
                url: "/api/WeightingsThresholds/saveFactorThreshold?RiskFactorId=" + AtViewModel.ClickedRiskFactorId() + "&AssessmentType=" + AtViewModel.AssessmentType() + "&TableType=F",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(ObjectData)
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveThresholdValues() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 1) {
                    for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                        for (var j = 0; j < AtViewModel.ThresholdValuesList()[i].ChildList().length; j++) {
                            var Value = AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName();
                            AtViewModel.ThresholdValuesListDup()[i].ChildList()[j].RiskLevelName(Value);
                        }
                    }
                    logger.logSuccess('Threshold Data saved successfully.', 'Success', system.getModuleId(AtViewModel), true);
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AtViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveThresholdValues() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveThresholdValues() method in SanctionsThreshold.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in SaveThresholdValues() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }
    }

    //-------------------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------
    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
            self.TargetRow = ko.observable();
            self.IsQualitative = ko.observable(item.IsQualitative);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    };

    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    };

    function ThresholdValueModel(item) {
        try {
            var self = this;
            self.IrlId = ko.observable(item.IrlId);
            self.IrlName = ko.observable(item.IrlName);
            var MappedChild = $.map(item.Child, function (result) {
                return new ThresholdChildModel(result);
            });
            self.ChildList = ko.observableArray(MappedChild);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdValueModel() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ThresholdChildModel(item) {
        try {
            var self = this;
            self.RiskLevelId = ko.observable(item.RiskLevelId);
            self.RiskLevelName = ko.observable(item.RiskLevelName);
            self.RiskLevelCss = ko.observable(item.RiskLevelCss);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdChildModel() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ValidateThresholdsValues(data) {
        var validation = true;
        $.each(AtViewModel.QualThresholdValuesList(), function (index, value) {
            var level = value.Level();
            if (parseFloat(value.Min()) >= parseFloat(value.Max())) {
                value.ShouldShowMessage(true);
                value.ValidationMessage("Max should be more then Min");
                validation = false;
            }
            else if (value.ShouldShowMessage()) {
                value.ShouldShowMessage(false);
                value.ValidationMessage(null);
                validation = true;
            }
        });
        return validation;

    }
    function SaveQualitativeThresholdValues(data) {
        try {
            if (ValidateThresholdsValues(data)) {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/QualitativeThresholds?AreaId=" + AtViewModel.ClickedRiskAreaId() + "&Type=SANC",
                    headers: headers,
                    traditional: true,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    //data:"[{'RecordID':'1','ItemName':'Some Value','CategoryID':'2'},{'RecordID':'2','ItemName':'Another Value','CategoryID':'4'},{'RecordID':'3','ItemName':'Whoohoo','CategoryID':'6'}]"
                    data: JSON.stringify($.map(AtViewModel.QualThresholdValuesList(), function (result) {


                        return {

                            Uid: result.Uid(),
                            Min: result.Min(),
                            Max: result.Max(),
                            Description: result.Description(),
                            Level: result.Level(),
                            Css: result.CSS()

                        }


                    }))

                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveThresholdValues() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }


        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 1) {
                    GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
                    logger.logSuccess('Qualitative Threshold Data saved successfully.', 'Success', system.getModuleId(AtViewModel), true);

                }

                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', true);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveQualitativeThresholdValues() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveQualitativeThresholdValues() method in SanctionsThreshold.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in SaveQualitativeThresholdValues() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }
    }

    function ResetQualitativeThresholdValues(data) {
        try {
            for (var i = 0; i < AtViewModel.QualThresholdValuesList().length; i++) {
                var valuemax = AtViewModel.QualThresholdValuesListDup()[i].Max();
                var valuemin = AtViewModel.QualThresholdValuesListDup()[i].Min();
                AtViewModel.QualThresholdValuesList()[i].Min(valuemin);
                AtViewModel.QualThresholdValuesList()[i].Max(valuemax);
                AtViewModel.QualThresholdValuesList()[i].ValidationMessage("");
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail  in ResetQualitativeThresholdValues() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }

    function GetQualThresholdData(data) {
        try {

            $.ajax({
                url: "/api/WeightingsThresholds/GetQualFactorThreshold",
                data: { "RiskAreaId": data, "AssessmentType": AtViewModel.AssessmentType() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQualThresholdData() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                $("#Sancerror").hide();
                $('#loadingImgMainQual').hide();
                $('#qualfactordiv').show();
                var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                    return new QualThresholdValueModel(result);
                });
                $('#tblThreshold tbody tr').remove();
                AtViewModel.QualThresholdValuesList(MappedQualThresholdValue);
                AtViewModel.QualThresholdValuesListDup([]);
                var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                    return new QualThresholdValueModel(result);
                });
                AtViewModel.QualThresholdValuesListDup(MappedThresholdValueDup);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQualThresholdData() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualThresholdData() method in SanctionsThreshold.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetQualThresholdData() method in SanctionsThreshold.js';
                logger.logMessage(msg);
            }
        }
    }

    function onKeyPressvalidateNumber(data, event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31
          && (charCode < 48 || charCode > 57))
            return false;
        return true;

    }

    function onBlurEvent(data) {
        var level = data.Level();
        if ($.isNumeric(data.Max())) {
            if (Number(data.Min()) >= Number(data.Max())) {
                data.ShouldShowMessage(true);
                data.ValidationMessage("Max should be more then Min");
            }
            else {
                data.ShouldShowMessage(false);
                data.ValidationMessage(null);
                $.each(AtViewModel.QualThresholdValuesList(), function (index, value) {
                    if (value.Level() == (level + 1)) {
                        value.Min(parseFloat(parseFloat(data.Max()) + 0.01).toFixed(2));
                    }
                });
            }
        }
        else {
            data.ShouldShowMessage(true);
            data.ValidationMessage("Non numeric values are not allowed");
        }
    }

    function QualThresholdValueModel(item) {
        try {

            var self = this;
            self.Uid = ko.observable(item.Uid);
            self.Min = ko.observable(item.Min);
            self.Max = ko.observable(item.Max);
            self.ValidationMessage = ko.observable(null);
            self.ShouldShowMessage = ko.observable(false);
            self.onBlur = function (data) {
                onBlurEvent(data);
            };
            self.Description = ko.observable($('<div/>').html(item.Description).text());
            //self.CSS = ko.observable($('<div/>').html(item.CSS).text());
            self.CSS = ko.observable(item.Css);
            self.Level = ko.observable(item.Level);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualThresholdValueModel() method in SanctionsThreshold.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------
});
